export enum OtpStatus {
    Passed = 'Passed',
    TryAgain = 'TryAgain',
    Failed = 'Failed',
    /** Terminal: OTP session is locked, no new code can be sent. */
    Locked = 'Locked',
    /**
     * Temporary cooldown: the resend cap was exhausted, so the user must wait
     * (~10 minutes) before a new code can be requested. Maps from the bff's
     * Cooldown status (security 9073 / MfaInCooldown).
     */
    Cooldown = 'Cooldown',
    /**
     * The current code's per-code retry attempts are exhausted, but the OTP
     * SESSION is still valid — resends remain. Unlike Locked/Cooldown (terminal,
     * route to mfa-failed), this surfaces an INLINE locked state on the verify
     * screen so the user can resend or switch channels and keep going.
     */
    CodeRetriesExhausted = 'CodeRetriesExhausted',
    DisambiguationRequired = 'DisambiguationRequired',
    ManualReviewRequired = 'ManualReviewRequired',
}
